import { modifier } from 'ember-modifier';

export default modifier((element, [callback]) => {
  callback(element);
});
